export enum WatermarkType {
  TEXT = 'text',
  IMAGE = 'image'
}
